import styles from './LoadingScreen.module.css';

interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({
  message = 'Loading your workspace...',
}: LoadingScreenProps) {
  return (
    <div aria-live="polite" className={styles.shell} role="status">
      <div className={styles.card}>
        <div aria-hidden="true" className={styles.spinner} />
        <p className={styles.message}>{message}</p>
      </div>
    </div>
  );
}
